import { render } from "./MessageItem.vue?vue&type=template&id=67d5e08c&scoped=true"
import script from "./MessageItem.vue?vue&type=script&lang=js"
export * from "./MessageItem.vue?vue&type=script&lang=js"

import "./MessageItem.vue?vue&type=style&index=0&id=67d5e08c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d5e08c"]])

export default __exports__